import { useEffect, useState } from "react";

import { WalletTopUpsService } from "../services/walletTopUps.service";
import type { WalletTopUp } from "../types/walletTopUps.types";

interface TopUpRead {
  id: string;
  topUp: WalletTopUp | null;
}

// A failed read (staff off the allowlist answer 403) leaves `topUp` null; the caller shows the leg alone.
export function useWalletTopUp(topUpId: string | null): { topUp: WalletTopUp | null; isLoading: boolean } {
  const [read, setRead] = useState<TopUpRead | null>(null);

  useEffect(() => {
    if (!topUpId) return;
    let cancelled = false;
    WalletTopUpsService.get(topUpId)
      .then((topUp) => {
        if (!cancelled) setRead({ id: topUpId, topUp });
      })
      .catch(() => {
        if (!cancelled) setRead({ id: topUpId, topUp: null });
      });
    return () => {
      cancelled = true;
    };
  }, [topUpId]);

  if (!topUpId) return { topUp: null, isLoading: false };
  if (read?.id !== topUpId) return { topUp: null, isLoading: true };
  return { topUp: read.topUp, isLoading: false };
}
